export default "__VITE_ASSET__1d18a166__"